import { useState, useEffect } from 'react';
import '../styles/sevices2.css'; // Assuming this is your CSS file for styling
import { Swiper, SwiperSlide } from 'swiper/react'; // Import Swiper components
import '../../node_modules/swiper/swiper-bundle.min.css'; // Import Swiper styles
import left from '../assests/Images/left.png';
import right from '../assests/Images/right.png';
import { useRef } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";
import axios from 'axios';
import 'swiper/css'; // Required core styles
import 'swiper/css/autoplay'; // (Optional, depends on version)
import { API_BASE_URL } from '../config/api';

const ServicesSection = ({ anim }) => {
  const [, setWindowWidth] = useState(window.innerWidth);
  const [swiperbreakpoints, setSwiperBreakpoints] = useState({
    320: { slidesPerView: 1 },
    768: { slidesPerView: 1 }, // Tablet view
    1024: { slidesPerView: 1 }, // Desktop view
  });
  
  const [onttimeIndex, setOntimeIndex] = useState(0); // For One Time pagination
  const [affairsData, setaffairsData] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false); // Add loading state

  const scrollLeft = (service) => {
    console.log(swiperbreakpoints);
    if (service === "oneTime" && swiperOneRef.current) {
      swiperOneRef.current.swiper.slidePrev();
    }
  }

  const scrollRight = (service) => {
    if (service === "oneTime" && swiperOneRef.current) {
      swiperOneRef.current.swiper.slideNext();
    }
  };

  const swiperOneRef = useRef(null);
  const intervalRef = useRef(null);
  const isHoveredRef = useRef(false);

  const startAutoSlide = () => {
    if (!intervalRef.current) {
      intervalRef.current = setInterval(() => {
        if (swiperOneRef.current && !isHoveredRef.current) {
          swiperOneRef.current.swiper.slidePrev();
        }
      }, 3000);
    }
  };

  const stopAutoSlide = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  useEffect(() => {
    startAutoSlide();
    return () => stopAutoSlide();
  }, []);

  // Update window width when the window is resized
  useEffect(() => {
    if (anim !== "true") {
      AOS.init({
        duration: 1000, // Optional: you can customize the animation duration or other settings
        once: true, // Optional: ensures animations only trigger once
        startEvent: 'DOMContentLoaded', // Optional: triggers AOS on specific event
      });
    }

    const fetchData = async () => {
      try {
        // Initialize with stored data if available
        const storedServices = localStorage.getItem("services");
        if (storedServices) {
          const parsedServices = JSON.parse(storedServices);
          const oneTimeServices = parsedServices.filter((service) => service.type === "one-time");
          setaffairsData(oneTimeServices);
        }

        const response = await axios.get(`${API_BASE_URL}/api/services/`);
        console.log(response.data.filter((service) => service.type === "renewal").length);
        localStorage.setItem("services", JSON.stringify(response.data));

        const response1 = await axios.get(`${API_BASE_URL}/api/marketing/banners/`);
        console.log("Response from API:", response1.data);
        
        let finaldata = [];
        var count = 6;
        
        // Check if primary array exists and has length
        if (response1.data.primary && Array.isArray(response1.data.primary)) {
          for (let i = response1.data.primary.length - 1; i >= 0; i--) {
            if (count === 0) break;
            finaldata.push(response1.data.primary[i]);
            count--;
          }
        }
        
        // Check if default array exists and has length
        if (response1.data.default && Array.isArray(response1.data.default)) {
          for (let i = response1.data.default.length - 1; i >= 0; i--) {
            if (count === 0) break;
            finaldata.push(response1.data.default[i]);
            count--;
          }
        }
        console.log("Final data:", finaldata);

     

        // Set the swiper breakpoints based on the number of services
        if (finaldata.length > 3) {
          setSwiperBreakpoints({
            320: { slidesPerView: 1 },
            768: { slidesPerView: 2 }, // Tablet view
            1024: { slidesPerView: 3 }, // Desktop view
          });
        } else {
          setSwiperBreakpoints({
            320: { slidesPerView: 1 },
            768: { slidesPerView:1}, // Tablet view
            1024: { slidesPerView: 1 }, // Desktop view
          });
        }

        setaffairsData(finaldata);
        setIsDataLoaded(true); // Mark data as loaded
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsDataLoaded(true); // Still mark as loaded to show component
      }
    };

    fetchData();

    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [anim]);

  // Handle Swiper slide change for pagination
  const handleSlideChangeOneTime = (swiper) => setOntimeIndex(swiper.realIndex);

  const getAosData = (anima, delay) => {
    return anim === "true" ? null : { "data-aos": anima, "data-aos-delay": delay };
  };

  // Calculate the number of circles for pagination
  const totalPagesOneTime = affairsData && Array.isArray(affairsData) ? affairsData.length : 0;

  // Don't render Swiper until data is loaded
  if (!isDataLoaded || !affairsData || !Array.isArray(affairsData) || affairsData.length === 0) {
    return (
      <div className="container-width services-section">
        <div className="d-flex justify-content-center">
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-width services-section">
      <div className="d-flex justify-content-between">
        <h1 {...getAosData("fade-up", 0)} className="section-title fs-2">Current Affairs</h1>
      </div>

      <h2 {...getAosData("fade-up", 0)} className="service-section-title pt-2">Explore our Captain's Current and Keep updated</h2>

      {/* One Time Services Section */}
      <div id="services-swiper-container"
        className="services-card-section mt-3 ">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex">
            <button {...getAosData("fade-left", 100)} onClick={() => scrollLeft("oneTime")} className="service-cursor-btn mobile-cursor"><img src={left} alt="Previous" /></button>
            <button {...getAosData("fade-right", 100)} onClick={() => scrollRight("oneTime")} className="service-cursor-btn mobile-cursor"><img src={right} alt="Next" /></button>
          </div>
        </div>
        
        <div onMouseEnter={() => {
          isHoveredRef.current = true;
        }}
        onMouseLeave={() => {
          isHoveredRef.current = false;
        }} className="d-flex justify-content-between align-items-center mt-3">
          <button {...getAosData("fade-left", 200)} onClick={() => scrollLeft("oneTime")} className="service-cursor-btn desktop-cursor"><img src={left} alt="Previous" /></button>

          <Swiper
            spaceBetween={20}
            breakpoints={swiperbreakpoints}
            onSlideChange={handleSlideChangeOneTime} // Event listener for slide change
            ref={swiperOneRef}
            {...getAosData("fade-up", 400)}
            className="pb-3"
            loop={true}  // Enable continuous loop
            key={JSON.stringify(swiperbreakpoints)} // Force re-render when breakpoints change
          >
            {affairsData && Array.isArray(affairsData) && affairsData.map((service, index) => (
              <SwiperSlide key={index}>
                <div className="col" style={{ position: "relative", height: '100%', padding: '10px', display: "flex", alignItems: "center", justifyContent: "center" }} >
                  <img src={service.image} alt="Service" className="" height="450px" style={{ minWidth: "300px",borderRadius:"20px" }} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          
          <button {...getAosData("fade-right", 200)} onClick={() => scrollRight("oneTime")} className="service-cursor-btn desktop-cursor"><img src={right} alt="Next" /></button>
        </div>
        
        {/* Custom Pagination for One Time Services */}
        <div {...getAosData("fade-up", 200)} className="slider-nav">
          <div className="circles">
            {Array.from({ length: totalPagesOneTime }).map((_, index) => (
              <span
                key={index}
                className={index === onttimeIndex ? 'circle active' : 'circle'}
              ></span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;